module.exports = __webpack_public_path__ + "img/yello-bat.2f880f5c.png";